export enum AbTestCampaignNameEnum {
  NewUserJourney = 'new-user-journey',
  MiTrust = 'mitrust',
}

export enum NewUserJourneyAbTestVariantEnum {
  BestPerf = 'continuous-improvement',
  BestMetier = 'orders',
  Test = 'test',
  TestPartnerChoice = 'test-partner-choice',
}

export enum MiTrustAbTestVariantEnum {
  MiTrustUpsell = 'mitrust-upsell',
  MiTrustSameLevel = 'mitrust-same-level',
  MiTrustDisabled = 'default',
}

export const abTestDefaultVariantMapping = {
  [AbTestCampaignNameEnum.NewUserJourney]: NewUserJourneyAbTestVariantEnum.BestPerf,
  [AbTestCampaignNameEnum.MiTrust]: MiTrustAbTestVariantEnum.MiTrustDisabled,
};

export const abTestVariantNameMapping = (
  abTest: NewUserJourneyAbTestVariantEnum | MiTrustAbTestVariantEnum | string
): string => {
  const mapping: Record<string, string> = {
    [NewUserJourneyAbTestVariantEnum.BestPerf]: 'Best Perf',
    [NewUserJourneyAbTestVariantEnum.BestMetier]: 'Best Métier',
    [NewUserJourneyAbTestVariantEnum.TestPartnerChoice]: 'Test choix du partenaire',

    [MiTrustAbTestVariantEnum.MiTrustUpsell]: 'MiTrust Activé (Upsell)',
    [MiTrustAbTestVariantEnum.MiTrustSameLevel]: 'MiTrust Activé (Same Level)',
    [MiTrustAbTestVariantEnum.MiTrustDisabled]: 'MiTrust Désactivé',
  };

  return mapping[abTest] || 'Inconnu';
};
